import gql from 'graphql-tag'

export const POSTING_QUERY = gql`
    query posting(
        $id: ID!
    ) {
        posting(
            id: $id
        ) {
            id
            type {
                id
                key
                name
                name_language_versions
                created_at
                updated_at
            }
            group {
                id
            }
            date
            number {
                id
                number
            }
            text
            debitAccount {
                id
                name
                number
            }
            creditAccount {
                id
                name
                number
            }
            amount
            attachments {
                id
                name
                size
                mime_type
            }
            is_confidential
            created_at
            updated_at
        }
    }
`
